const expandedRoutes = [
  '/app-manager',
  '/workflow-list',
  '/canvas/empty',
  '/workspace',
  '/workbench',
  '/home',
  '/project',
  '/marketplace',
  '/template-market',
  '/social-account',
  '/digital-human',
  '/media-library',
  '/my-assets',
  '/media-publish',
  '/video-editor',
];

const exactExpandedRoutes = ['/run-history'];

export const shouldExpandSider = (currentPath: string): boolean => {
  return (
    expandedRoutes.some((route) => {
      if (route === '/home') {
        return currentPath === '/';
      }
      if (route === '/canvas/empty') {
        return currentPath === '/canvas/empty';
      }
      if (route === '/workspace') {
        return currentPath === '/workspace';
      }

      return currentPath.startsWith(route);
    }) || exactExpandedRoutes.includes(currentPath)
  );
};
